import api from './index';
import { INSTITUTIONS_LIST_PER_PAGE_ITEMS } from '../../app.config.vars/stored';
const endpoints = {
    institutions: '/admin/institutions',
};
export const getInstitutions = async (currentPage) => {
    const res = await api.get(endpoints.institutions, {
        params: {
            page: currentPage,
            limit: INSTITUTIONS_LIST_PER_PAGE_ITEMS,
        },
    });
    return res.data;
};
export const getInstitution = async (id) => {
    const res = await api.get(`${endpoints.institutions}/${id}`);
    return res.data;
};
export const addInstitution = async (body) => {
    return await api.post(endpoints.institutions, body);
};
export const updateInstitution = async (id, body) => {
    return await api.patch(`${endpoints.institutions}/${id}`, body);
};
export const deleteInstitution = async (id) => {
    return await api.delete(`${endpoints.institutions}/${id}`);
};
